import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, Check, Users, Calendar, Zap } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ContactModal from '../components/ContactModal';

const TarifsPage = () => {
  const [isContactModalOpen, setIsContactModalOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header scrollY={100} />
      
      <div className="pt-24 pb-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link to="/" className="inline-flex items-center text-green-600 hover:text-green-700 mb-8 transition-colors">
            <ArrowLeft className="w-5 h-5 mr-2" />
            Retour à l'accueil
          </Link>
          
          <div className="mb-12">
            <h1 className="text-5xl font-bold text-gray-900 mb-4">
              Tarifs
            </h1>
            <p className="text-xl text-gray-600">
              Cotisations et tarifs de location
            </p>
          </div>

          {/* Tableau des tarifs - Format original */}
          <div className="bg-white rounded-2xl shadow-xl overflow-hidden mb-16">
            <div className="overflow-x-auto">
              <table className="w-full">
                <thead>
                  <tr className="bg-gradient-to-r from-green-600 to-emerald-600 text-white">
                    <th className="px-6 py-4 text-left font-bold">Catégories pour les membres</th>
                    <th className="px-6 py-4 text-left font-bold">Tarif annuel AVEC Participation au(x) loto(s)</th>
                    <th className="px-6 py-4 text-left font-bold">Tarif annuel SANS Participation au(x) loto(s)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border-b border-gray-200 hover:bg-green-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="font-bold text-gray-900">Juniors</div>
                      <div className="text-sm text-gray-600">jusqu'à 18 ans</div>
                    </td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 50.-</td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 50.-</td>
                  </tr>
                  <tr className="border-b border-gray-200 hover:bg-blue-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="font-bold text-gray-900">Apprenti ou étudiant</div>
                      <div className="text-sm text-gray-600">jusqu'à 25 ans</div>
                    </td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 150.-</td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 250.-</td>
                  </tr>
                  <tr className="border-b border-gray-200 hover:bg-purple-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="font-bold text-gray-900">Actif</div>
                    </td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 240.-</td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 340.-</td>
                  </tr>
                  <tr className="border-b border-gray-200 hover:bg-orange-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="font-bold text-gray-900">Couple</div>
                    </td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 420.-</td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 550.-</td>
                  </tr>
                  <tr className="border-b border-gray-200 hover:bg-pink-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="font-bold text-gray-900">Famille</div>
                    </td>
                    <td className="px-6 py-4 font-semibold text-gray-900" colspan="2">1 adulte = 1 enfant gratuit</td>
                  </tr>
                  <tr className="border-b border-gray-200 hover:bg-gray-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="font-bold text-gray-900">Passif</div>
                    </td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 20.-</td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 20.-</td>
                  </tr>
                  <tr className="border-b border-gray-200 hover:bg-yellow-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="font-bold text-gray-900">Non membre</div>
                      <div className="text-sm text-gray-600">par heure pour un court de tennis</div>
                    </td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 25.-</td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 25.-</td>
                  </tr>
                  <tr className="hover:bg-yellow-50 transition-colors">
                    <td className="px-6 py-4">
                      <div className="font-bold text-gray-900">Non membre</div>
                      <div className="text-sm text-gray-600">par heure pour un court de padel</div>
                    </td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 40.-</td>
                    <td className="px-6 py-4 font-semibold text-gray-900">Fr. 40.-</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* Info sur les lotos */}
          <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl mb-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-4">À propos de la participation aux lotos</h3>
            <p className="text-gray-700 leading-relaxed">
              Le club organise des lotos tout au long de l'année. En choisissant le tarif "AVEC Participation au(x) loto(s)", 
              vous vous engagez à participer activement à l'organisation de ces événements, ce qui permet de bénéficier 
              d'une réduction sur la cotisation annuelle. Cette participation aide le club à financer ses activités et 
              à améliorer les installations.
            </p>
          </div>

          <div className="bg-gray-900 text-white p-12 rounded-3xl">
            <h2 className="text-3xl font-bold mb-6">Questions sur les tarifs ?</h2>
            <p className="text-gray-300 mb-8 text-lg">
              N'hésitez pas à nous contacter pour plus d'informations sur nos tarifs et les modalités d'inscription.
            </p>
            <button 
              onClick={() => setIsContactModalOpen(true)}
              className="inline-block bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-xl font-semibold transition-all hover:scale-105"
            >
              Nous contacter
            </button>
          </div>
        </div>
      </div>

      <ContactModal 
        isOpen={isContactModalOpen} 
        onClose={() => setIsContactModalOpen(false)} 
      />

      <Footer />
    </div>
  );
};

export default TarifsPage;